<ul>
  <li>
    <span> @ 2021 Bentley Systems, Incorporated </span>
  </li>
  <li role="separator" class="divider">
    <span>|</span>
  </li>
  <li>
    <a [href]="termsOfservice" target="_blank">Terms of Service</a>
  </li>
  <li role="separator" class="divider">
    <span>|</span>
  </li>
  <li>
    <a [href]="privacy" target="_blank">Privacy</a>
  </li>
  <li role="separator" class="divider">
    <span>|</span>
  </li>
  <li>
    <a [href]="termsOfUse" target="_blank">Terms of Use</a>
  </li>
  <li role="separator" class="divider">
    <span>|</span>
  </li>
  <li>
    <a [href]="cookies" target="_blank">Cookies</a>
  </li>
  <li role="separator" class="divider">
    <span>|</span>
  </li>
  <li>
    <a [href]="leagalnotices" target="_blank">Legal Notices</a>
  </li>
  <li role="separator" class="divider">
    <span>|</span>
  </li>
  <li>
    <a [href]="attributions" target="_blank">Attributions</a>
  </li>
</ul>
